/**
 * @generated SignedSource<<9720ad991fbe7340c0e669cae92a6e3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UsersWhoMadeContentNodeTable_Query$variables = {
  after?: string | null | undefined;
  contentNodeId?: string | null | undefined;
  filterByFirstName?: string | null | undefined;
  filterByLastName?: string | null | undefined;
  first?: number | null | undefined;
};
export type UsersWhoMadeContentNodeTable_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UsersWhoMadeContentNodeTable_Fragment">;
};
export type UsersWhoMadeContentNodeTable_Query = {
  response: UsersWhoMadeContentNodeTable_Query$data;
  variables: UsersWhoMadeContentNodeTable_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentNodeId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByFirstName"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterByLastName"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "contentNodeId",
    "variableName": "contentNodeId"
  },
  {
    "kind": "Variable",
    "name": "filterByFirstName",
    "variableName": "filterByFirstName"
  },
  {
    "kind": "Variable",
    "name": "filterByLastName",
    "variableName": "filterByLastName"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  (v6/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountCode",
        "storageKey": null
      }
    ],
    "type": "InfectopharmUserExtension",
    "abstractKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UsersWhoMadeContentNodeTable_Query",
    "selections": [
      {
        "args": (v5/*: any*/),
        "kind": "FragmentSpread",
        "name": "UsersWhoMadeContentNodeTable_Fragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "UsersWhoMadeContentNodeTable_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UsersListAdminSchema",
            "kind": "LinkedField",
            "name": "UsersList",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "AllUsers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "userExtensionKind",
                                "value": "InfectopharmUserExtension"
                              }
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "extension",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "filters": [
                  "contentNodeId",
                  "filterByFirstName",
                  "filterByLastName"
                ],
                "handle": "connection",
                "key": "UsersWhoMadeContentNodeTable_AllUsers",
                "kind": "LinkedHandle",
                "name": "AllUsers"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "68eb8ba189fc64549fce503b87993253",
    "id": null,
    "metadata": {},
    "name": "UsersWhoMadeContentNodeTable_Query",
    "operationKind": "query",
    "text": "query UsersWhoMadeContentNodeTable_Query(\n  $contentNodeId: ID\n  $first: Int\n  $after: String\n  $filterByLastName: String\n  $filterByFirstName: String\n) {\n  ...UsersWhoMadeContentNodeTable_Fragment_2zKqJw\n}\n\nfragment UserActionColumn_NodeFragment on User {\n  id\n  ...UserContentSubmissionDialog_UserFragment\n}\n\nfragment UserContentSubmissionDialog_UserFragment on User {\n  id\n  extension(userExtensionKind: InfectopharmUserExtension) {\n    __typename\n    ... on InfectopharmUserExtension {\n      firstName\n      lastName\n    }\n  }\n}\n\nfragment UsersWhoMadeContentNodeTable_Fragment_2zKqJw on Query {\n  Admin {\n    UsersList {\n      AllUsers(first: $first, after: $after, contentNodeId: $contentNodeId, filterByFirstName: $filterByFirstName, filterByLastName: $filterByLastName) {\n        pageInfo {\n          endCursor\n          hasPreviousPage\n          hasNextPage\n          startCursor\n        }\n        edges {\n          node {\n            id\n            extensions {\n              __typename\n              ... on InfectopharmUserExtension {\n                firstName\n                lastName\n                accountCode\n              }\n            }\n            ...UserContentSubmissionDialog_UserFragment\n            ...userNameColumn_Fragment\n            ...UserActionColumn_NodeFragment\n            ...accountCodeColumn_Fragment\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n}\n\nfragment accountCodeColumn_Fragment on User {\n  extension(userExtensionKind: InfectopharmUserExtension) {\n    __typename\n    ... on InfectopharmUserExtension {\n      accountCode\n    }\n  }\n}\n\nfragment userNameColumn_Fragment on User {\n  extension(userExtensionKind: InfectopharmUserExtension) {\n    __typename\n    ... on InfectopharmUserExtension {\n      firstName\n      lastName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a9ed9522070be9fb2bf5f20b399246b4";

export default node;
